import APIS from 'src/constants/ApiConfig';
import HttpService from 'src/services/HttpService';

/**
 * 拼音数据结构
 *
 * @export
 * @interface IPinYin
 */
export interface IPinYin {
  pinyin?: string;
  chinese?: string;
}

export const getWordUrl = (url: string) => {
  return APIS.domainApi(url);
};

export class WordService {
  /**
   * 通过描述获取拼音
   *
   * @static
   * @param {string} desc
   * @returns {Promise<string>}
   * @memberof WordService
   */
  static async getPinyinByDesc(desc: string): Promise<string> {
    try {
      const url = getWordUrl(APIS.pinyin);
      const res: IPinYin = await HttpService.post(url, {
        chinese: desc,
      });
      if (!!res) {
        return res.pinyin || '';
      }
    } catch (error) {
      console.error(error);
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/services/WordService.ts